import SnackbarUtils from '../SnackbarUtils/SnackbarUtlis';

export default function errorMessage(error) {
    if (error && error !== undefined && error.status === 401) {
        window.location.href = "/";
        SnackbarUtils.warning('Sorry');
    } else {
        SnackbarUtils.error('Something went wrong!');
    }
}
